import type { MuiPage } from '@mui/internal-core-docs/MuiPage';

const chatApiPages: MuiPage[] = [
  {
    pathname: '/x/api/chat/chat-box',
    title: 'ChatBox',
  },
  {
    pathname: '/x/api/chat/chat-code-block',
    title: 'ChatCodeBlock',
  },
  {
    pathname: '/x/api/chat/chat-composer-attach-button',
    title: 'ChatComposerAttachButton',
  },
  {
    pathname: '/x/api/chat/chat-composer-attachment-list',
    title: 'ChatComposerAttachmentList',
  },
  {
    pathname: '/x/api/chat/chat-composer-helper-text',
    title: 'ChatComposerHelperText',
  },
  {
    pathname: '/x/api/chat/chat-composer-label',
    title: 'ChatComposerLabel',
  },
  {
    pathname: '/x/api/chat/chat-composer-send-button',
    title: 'ChatComposerSendButton',
  },
  {
    pathname: '/x/api/chat/chat-composer-text-area',
    title: 'ChatComposerTextArea',
  },
  {
    pathname: '/x/api/chat/chat-composer-toolbar',
    title: 'ChatComposerToolbar',
  },
  {
    pathname: '/x/api/chat/chat-confirmation',
    title: 'ChatConfirmation',
  },
  {
    pathname: '/x/api/chat/chat-conversation',
    title: 'ChatConversation',
  },
  {
    pathname: '/x/api/chat/chat-conversation-header',
    title: 'ChatConversationHeader',
  },
  {
    pathname: '/x/api/chat/chat-conversation-header-actions',
    title: 'ChatConversationHeaderActions',
  },
  {
    pathname: '/x/api/chat/chat-conversation-header-info',
    title: 'ChatConversationHeaderInfo',
  },
  {
    pathname: '/x/api/chat/chat-conversation-list',
    title: 'ChatConversationList',
  },
  {
    pathname: '/x/api/chat/chat-conversation-subtitle',
    title: 'ChatConversationSubtitle',
  },
  {
    pathname: '/x/api/chat/chat-conversation-title',
    title: 'ChatConversationTitle',
  },
  {
    pathname: '/x/api/chat/chat-date-divider',
    title: 'ChatDateDivider',
  },
  {
    pathname: '/x/api/chat/chat-layout',
    title: 'ChatLayout',
  },
  {
    pathname: '/x/api/chat/chat-message-actions',
    title: 'ChatMessageActions',
  },
  {
    pathname: '/x/api/chat/chat-message-author-label',
    title: 'ChatMessageAuthorLabel',
  },
  {
    pathname: '/x/api/chat/chat-message-avatar',
    title: 'ChatMessageAvatar',
  },
  {
    pathname: '/x/api/chat/chat-message-content',
    title: 'ChatMessageContent',
  },
  {
    pathname: '/x/api/chat/chat-message-group',
    title: 'ChatMessageGroup',
  },
  {
    pathname: '/x/api/chat/chat-message-inline-meta',
    title: 'ChatMessageInlineMeta',
  },
  {
    pathname: '/x/api/chat/chat-message-list',
    title: 'ChatMessageList',
  },
  {
    pathname: '/x/api/chat/chat-message-meta',
    title: 'ChatMessageMeta',
  },
  {
    pathname: '/x/api/chat/chat-message-skeleton',
    title: 'ChatMessageSkeleton',
  },
  {
    pathname: '/x/api/chat/chat-message-source',
    title: 'ChatMessageSource',
  },
  {
    pathname: '/x/api/chat/chat-message-sources',
    title: 'ChatMessageSources',
  },
  {
    pathname: '/x/api/chat/chat-provider',
    title: 'ChatProvider',
  },
  {
    pathname: '/x/api/chat/chat-root',
    title: 'ChatRoot',
  },
  {
    pathname: '/x/api/chat/chat-scroll-to-bottom-affordance',
    title: 'ChatScrollToBottomAffordance',
  },
  {
    pathname: '/x/api/chat/chat-suggestions',
    title: 'ChatSuggestions',
  },
  {
    pathname: '/x/api/chat/chat-typing-indicator',
    title: 'ChatTypingIndicator',
  },
  {
    pathname: '/x/api/chat/chat-unread-marker',
    title: 'ChatUnreadMarker',
  },
  {
    pathname: '/x/api/chat/composer-attach-button',
    title: 'ComposerAttachButton',
  },
  {
    pathname: '/x/api/chat/composer-attachment-list',
    title: 'ComposerAttachmentList',
  },
  {
    pathname: '/x/api/chat/composer-helper-text',
    title: 'ComposerHelperText',
  },
  {
    pathname: '/x/api/chat/composer-label',
    title: 'ComposerLabel',
  },
  {
    pathname: '/x/api/chat/composer-root',
    title: 'ComposerRoot',
  },
  {
    pathname: '/x/api/chat/composer-send-button',
    title: 'ComposerSendButton',
  },
  {
    pathname: '/x/api/chat/composer-text-area',
    title: 'ComposerTextArea',
  },
  {
    pathname: '/x/api/chat/composer-toolbar',
    title: 'ComposerToolbar',
  },
  {
    pathname: '/x/api/chat/conversation-header',
    title: 'ConversationHeader',
  },
  {
    pathname: '/x/api/chat/conversation-header-actions',
    title: 'ConversationHeaderActions',
  },
  {
    pathname: '/x/api/chat/conversation-list-item',
    title: 'ConversationListItem',
  },
  {
    pathname: '/x/api/chat/conversation-list-item-avatar',
    title: 'ConversationListItemAvatar',
  },
  {
    pathname: '/x/api/chat/conversation-list-preview',
    title: 'ConversationListPreview',
  },
  {
    pathname: '/x/api/chat/conversation-list-root',
    title: 'ConversationListRoot',
  },
  {
    pathname: '/x/api/chat/conversation-list-timestamp',
    title: 'ConversationListTimestamp',
  },
  {
    pathname: '/x/api/chat/conversation-list-title',
    title: 'ConversationListTitle',
  },
  {
    pathname: '/x/api/chat/conversation-list-unread-badge',
    title: 'ConversationListUnreadBadge',
  },
  {
    pathname: '/x/api/chat/conversation-root',
    title: 'ConversationRoot',
  },
  {
    pathname: '/x/api/chat/conversation-subtitle',
    title: 'ConversationSubtitle',
  },
  {
    pathname: '/x/api/chat/conversation-title',
    title: 'ConversationTitle',
  },
  {
    pathname: '/x/api/chat/message-actions',
    title: 'MessageActions',
  },
  {
    pathname: '/x/api/chat/message-author-label',
    title: 'MessageAuthorLabel',
  },
  {
    pathname: '/x/api/chat/message-avatar',
    title: 'MessageAvatar',
  },
  {
    pathname: '/x/api/chat/message-content',
    title: 'MessageContent',
  },
  {
    pathname: '/x/api/chat/message-error',
    title: 'MessageError',
  },
  {
    pathname: '/x/api/chat/message-group',
    title: 'MessageGroup',
  },
  {
    pathname: '/x/api/chat/message-list-date-divider',
    title: 'MessageListDateDivider',
  },
  {
    pathname: '/x/api/chat/message-list-root',
    title: 'MessageListRoot',
  },
  {
    pathname: '/x/api/chat/message-meta',
    title: 'MessageMeta',
  },
  {
    pathname: '/x/api/chat/message-root',
    title: 'MessageRoot',
  },
  {
    pathname: '/x/api/chat/scroll-to-bottom-affordance',
    title: 'ScrollToBottomAffordance',
  },
  {
    pathname: '/x/api/chat/typing-indicator',
    title: 'TypingIndicator',
  },
  {
    pathname: '/x/api/chat/unread-marker',
    title: 'UnreadMarker',
  },
];
export default chatApiPages;
